// Dynamic Price Display & LoyaltyLion Updater
// This script handles two main functions:
// 1. Updates visible price displays in product elements (including fallback for empty metafields)
// 2. Synchronizes price changes with LoyaltyLion for points calculation
// 
// Covers: PDPs, quick view modals, subscription/frequency widgets, and OTP products.
// It is safe, non-blocking, and works with all major payment/frequency widget patterns.
(function() {
  function updateLionPrice(priceCents, container) {
    try {
      // Find the hidden price span by data attribute, scoped to container if provided
      let priceSpan;
      if (container) {
        priceSpan = container.querySelector('[data-lion-price-for-product-id]');
      } else {
        priceSpan = document.querySelector('[data-lion-price-for-product-id]');
      }
      if (priceSpan) {
        priceSpan.innerText = "$" + parseFloat(priceCents / 100).toFixed(2);
      }
    } catch (e) {
      console.warn('[LoyaltyLionPDP] Failed to update hidden price:', e);
    }
  }

  function refreshLoyaltyLion(context, container) {
    try {
      // If LoyaltyLion supports scoping, you could pass the container here
      if (window.loyaltylion && loyaltylion.ui && typeof loyaltylion.ui.refresh === 'function') {
        loyaltylion.ui.refresh();
      }
    } catch (e) {
      console.warn('[LoyaltyLionPDP] LoyaltyLion refresh failed:', e);
    }
  }

  function getModalContainer(element) {
    // Add selectors for your modal types here
    return element.closest('.quick-add-modal, product-modal, modal-dialog');
  }

  function handleOptionOrFrequencyClick(optionEl, context) {
    let price = optionEl.getAttribute('data-price');
    
    if (!price) {
      // Check for span.info first
      const infoSpan = optionEl.querySelector('.info');
      if (infoSpan) {
        const match = infoSpan.innerText.match(/\$([0-9.]+)/);
        if (match) price = parseFloat(match[1]) * 100;
      }
      
      // Then check box-info if no price found
      if (!price) {
        const boxInfo = optionEl.querySelector('.box-info');
        if (boxInfo) {
          const match = boxInfo.innerText.match(/\$([0-9.]+)/);
          if (match) price = parseFloat(match[1]) * 100;
        }
      }
      
      // Finally check h4 if still no price
      if (!price) {
        const h4 = optionEl.querySelector('.h4');
        if (h4) {
          const match = h4.textContent.match(/\$([0-9.]+)/);
          if (match) price = parseFloat(match[1]) * 100;
        }
      }
    }
    if (price) {
      const modalContainer = getModalContainer(optionEl);
      updateLionPrice(price, modalContainer);
      refreshLoyaltyLion(context, modalContainer);
    }
  }

  function attachListeners() {
    const optionSelectors = [
      '.subscription_option',
      '.onetime_option',
      '.option',
      '.frequency_option',
    ];

    optionSelectors.forEach(selector => {
      document.querySelectorAll(selector).forEach(optionEl => {
        optionEl.addEventListener('click', function(event) {
          handleOptionOrFrequencyClick(optionEl, 'option/frequency click: ' + selector);
        });
      });
    });

    // Listen for frequency option clicks inside delivery-frequency-widget custom elements
    document.querySelectorAll('delivery-frequency-widget').forEach(widget => {
      widget.querySelectorAll('.frequency_option').forEach(freqOption => {
        freqOption.addEventListener('click', function(event) {
          handleOptionOrFrequencyClick(freqOption, 'frequency_option click inside delivery-frequency-widget');
        });
      });
    });

    // Also listen for change events on <select> frequency dropdowns, if present
    document.querySelectorAll('select.rc_select__frequency, select[data-frequency-select]').forEach(selectEl => {
      selectEl.addEventListener('change', function(event) {
        // Try to get the selected option's data-price or parse from text
        let price = null;
        const selectedOption = selectEl.options[selectEl.selectedIndex];
        price = selectedOption.getAttribute('data-price');
        if (!price) {
          const match = selectedOption.textContent.match(/\$([0-9.]+)/);
          if (match) price = parseFloat(match[1]) * 100;
        }
        if (price) {
          const modalContainer = getModalContainer(selectEl);
          updateLionPrice(price, modalContainer);
          refreshLoyaltyLion('frequency select change', modalContainer);
        }
      });
    });
  }

  function loadInitialPoints() {
    let priceSet = false;
    // For each option group, trigger the handler for the selected/active option
    const optionSelectors = [
      '.subscription_option',
      '.onetime_option',
      '.option',
      '.frequency_option',
    ];
    optionSelectors.forEach(selector => {
      document.querySelectorAll(selector).forEach(optionEl => {
        if (
          optionEl.classList.contains('active') ||
          optionEl.classList.contains('selected') ||
          optionEl.querySelector('input[type="radio"]:checked')
        ) {
          handleOptionOrFrequencyClick(optionEl, 'initial load: ' + selector);
          priceSet = true;
        }
      });
    });

    // For frequency selects, trigger the handler for the selected option
    document.querySelectorAll('select.rc_select__frequency, select[data-frequency-select]').forEach(selectEl => {
      const selectedOption = selectEl.options[selectEl.selectedIndex];
      let price = selectedOption.getAttribute('data-price');
      if (!price) {
        const match = selectedOption.textContent.match(/\$([0-9.]+)/);
        if (match) price = parseFloat(match[1]) * 100;
      }
      if (price) {
        const modalContainer = getModalContainer(selectEl);
        updateLionPrice(price, modalContainer);
        refreshLoyaltyLion('initial load: frequency select', modalContainer);
        priceSet = true;
      }
    });

    // Fallback: If no price was set, look for .info in modal or page
    if (!priceSet) {
      // Check in all modal containers and the main page
      const containers = Array.from(document.querySelectorAll('.quick-add-modal, product-modal, modal-dialog'));
      containers.push(document.body); // Also check the main page
      containers.forEach(container => {
        const infoSpan = container.querySelector('.info');
        if (infoSpan) {
          const match = infoSpan.innerText.match(/\$([0-9.]+)/);
          if (match) {
            const price = parseFloat(match[1]) * 100;
            updateLionPrice(price, container === document.body ? null : container);
            refreshLoyaltyLion('initial load: .info fallback', container === document.body ? null : container);
            priceSet = true;
          }
        }
      });
    }

    // Show loyalty points container if a price was found
    if (priceSet) {
      const pointsContainers = document.querySelectorAll('.loyalty-points-container');
      pointsContainers.forEach(container => {
        container.style.display = '';
        container.classList.add('loyalty-points-loaded');
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      attachListeners();
      loadInitialPoints();
    });
  } else {
    attachListeners();
    loadInitialPoints();
  }
})(); 